/**
 * [NiceMatrix] OSS onboarding survey is disabled in our self-hosted Logto.
 *
 * Logto v1.39 added an OSS onboarding flow that, when DEV_FEATURES_ENABLED=true,
 * forces every fresh admin user through `/console/<tenant>/onboarding`
 * before they can use the console. We don't ship the questionnaire to our
 * users. Since 1.45 we run with DEV_FEATURES_ENABLED=false (see
 * logto-custom/Dockerfile), so upstream would not redirect either; the bypass
 * stays so that re-enabling the flag can never bring the questionnaire back.
 */
import { Outlet } from 'react-router-dom';

function OssOnboardingGuard() {
  return <Outlet />;
}

export default OssOnboardingGuard;
